/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formcontent_General_Subjecttopb4Inputs */

const ja_contact_formcontent_general_subjecttopb4 = /** @type {(inputs: Contact_Formcontent_General_Subjecttopb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const en_contact_formcontent_general_subjecttopb4 = /** @type {(inputs: Contact_Formcontent_General_Subjecttopb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enquiry to`)
};

/**
* | output |
* | --- |
* | "Enquiry to" |
*
* @param {Contact_Formcontent_General_Subjecttopb4Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formcontent_general_subjecttopb4 = /** @type {((inputs?: Contact_Formcontent_General_Subjecttopb4Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formcontent_General_Subjecttopb4Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formcontent_general_subjecttopb4(inputs)
	return en_contact_formcontent_general_subjecttopb4(inputs)
});
export { contact_formcontent_general_subjecttopb4 as "contact_formContent_general_subjectToPB" }